module.exports = __webpack_public_path__ + "img/team-icon.3c4fbfd3.png";